module.exports = __webpack_public_path__ + "static/media/external_4.714ce11f.jpg";